// Pure gate rule for leaving the "Type de réservation" step. Kept
// framework-free so the rule is unit-testable without rendering the component.
//
// A venue choice is mandatory as soon as any venue-bearing service (dîner or
// logement) is selected: the wire payload derives its rooms from the venue
// sub-selection, and an empty venue silently falls back to 'dinerlatable' —
// which booked La Table on a serre-only date (2026-06-12 double booking).

export interface TypeStepState {
  dinerQuantity: number;
  logementQuantity: number;
  venue: 'lasalle' | 'serre' | '';
}

export function canLeaveTypeStep(state: TypeStepState): boolean {
  const hasService = state.dinerQuantity > 0 || state.logementQuantity > 0;
  return hasService && state.venue !== '';
}
